export default {
  methods: {
    showAge: function(age)
    {
      switch(age){
        case 1:
        case 'from10to19':
          return this.$t('Analysis.User.age10');
        case 2:
        case 'from20to29':
          return this.$t('Analysis.User.age20');
        case 3:
        case 'from30to39':
          return this.$t('Analysis.User.age30');
        case 4:
        case 'from40to49':
          return this.$t('Analysis.User.age40');
        case 5:
        case 'from50to59':
          return this.$t('Analysis.User.age50');
        case 6:
        case 'from60to69':
          return this.$t('Analysis.User.age60');
        case 7:
        case 'over70':
          return this.$t('Analysis.User.age70');
        case 'other':
        case '_unknown':
          return this.$t('Analysis.User.ageOther');
      }
    },

    getAgesInOrder() {
      return ['from10to19', 'from20to29', 'from30to39', 'from40to49', 'from50to59', 'from60to69', 'over70', 'other']
    },

    getAgeLabelsInOrder() {
      return this.getAgesInOrder().map(a => this.showAge(a));
    },

    showGender: function(gender)
    {
      switch(gender){
        case "male":   return this.$t('Analysis.User.male');
        case "female": return this.$t('Analysis.User.female');
        case "other":  return this.$t('Analysis.User.other');
      }
    }
  }
}
